<template>
  <v-footer
    id="footer"
    dark
    padless
  >
    <v-card
      class="flex"
      flat
      tile
      color="#E9E5DD"
      light
      height="105px"
    >
      <v-card-title>
        <v-btn
          v-for="(link, index) in links"
          :key="index"
          color="#999999"
          text
          rounded
          class="my-2"
          :href="link.externalUrl"
          :target="link.externalUrl ? '_blank' : undefined"
          :to="link.externalUrl ? undefined : { name: link.routeName }"
        >
          {{ link.name }}
        </v-btn>

        <v-spacer></v-spacer>

        <a
          href="https://certainfee.com/#contact"
          target="_blank"
          class="text"
          rel="noopener noreferrer"
        >
          Connect with CertainFee
        </a>
        <v-btn
          class="mx-4"
          color="#999999"
          icon
          href="https://www.facebook.com/certainfee/?ref=pages_you_manage"
          target="_blank"
        >
          <v-icon size="24px">
            mdi-facebook
          </v-icon>
        </v-btn>
        <!-- Instagram link disabled - only Facebook works
        <v-btn
          class="mx-4"
          color="#999999"
          icon
          href="https://www.instagram.com/crites_business_solutions/"
          target="_blank"
        >
          <v-icon size="24px">
            mdi-instagram
          </v-icon>
        </v-btn>
        -->
      </v-card-title>

    </v-card>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      {
        name: 'Home',
        routeName: 'Home',
      },
      {
        name: 'How To & FAQ',
        routeName: 'ContactUs',
        externalUrl: 'https://certainfee.com/services/',
      },
      {
        name: 'Contact',
        routeName: 'ContactUs',
        externalUrl: 'https://certainfee.com/#contact',
      },
    ],
  })
}
</script>

<style scoped>
.text {
  font-size: 10pt;
  font-family: "NunitoSans-Bold";
  color: #999999;
  text-decoration: none;
}
</style>